"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Funnel = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Funnel"));

// Generated by script, don't edit it please.
var Funnel = (0, _createSvgIcon["default"])({
  as: _Funnel["default"],
  ariaLabel: 'funnel',
  category: 'action',
  displayName: 'Funnel'
});
var _default = Funnel;
exports["default"] = _default;
module.exports = exports.default;